// extracted by mini-css-extract-plugin
module.exports = {"content":"Home_content__dAlfs","tagLine":"Home_tagLine__T6g2v","tagLineSupport":"Home_tagLineSupport__kDgaQ","filters":"Home_filters___3oEr"};